<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :label="$t('CargoMsg.Cargo_SeaFreightFullContainer')" name="inquirySeaFcl">
          <inquiry-sea-fcl-list
            ref="inquirySeaFclList"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import inquirySeaFclList from '@/components/Cargo/Inquiry/inquirySeaFclList'

export default {
  name: 'Inquiry',
  components: { inquirySeaFclList },
  data() {
    return {
      SystemConstants,
      activeTabName: 'inquirySeaFcl'
    }
  }
}
</script>

<style scoped>

</style>
